import { jsx as s } from "react/jsx-runtime";
import { c as l } from "react/compiler-runtime";
import { AccordionDetails as m } from "@mui/material";
import { forwardRef as a } from "react";
const n = a((t, c) => {
  const o = l(7);
  let r, i;
  o[0] !== t ? ({
    children: r,
    ...i
  } = t, o[0] = t, o[1] = r, o[2] = i) : (r = o[1], i = o[2]);
  let e;
  return o[3] !== r || o[4] !== i || o[5] !== c ? (e = /* @__PURE__ */ s(m, { ref: c, ...i, children: r }), o[3] = r, o[4] = i, o[5] = c, o[6] = e) : e = o[6], e;
});
n.displayName = "AccordionDetails";
export {
  n as AccordionDetails
};
